export const ACTIONS_LIST = {
    actions:[],
    state:null
}